/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { gameGetGameEpicFree } from "../../funcs/gameGetGameEpicFree.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$gameGetGameEpicFree: ToolDefinition = {
  name: "game-get-game-epic-free",
  description: `Epic 免费游戏

白嫖党的福音来了！想第一时间知道Epic商店本周送了哪些游戏大作吗？

## 功能概述
这个接口帮你实时追踪Epic Games商店的每周免费游戏活动。无需任何参数，调用后即可获得当前所有免费游戏的完整信息，包括游戏封面、原价、剩余时间等，再也不用担心错过心仪的免费游戏了！

## 使用场景
- 开发游戏资讯应用或网站
- 制作Epic免费游戏推送机器人
- 为用户提供游戏收藏建议
- 构建个人游戏库管理工具

> [!TIP]
> **关于时间格式**
> 为了方便不同场景的使用，我们同时提供了可读的时间字符串（如 \`2025/01/10 00:00:00\`）和13位毫秒时间戳。前端显示用字符串，程序逻辑用时间戳`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  tool: async (client, ctx) => {
    const [result] = await gameGetGameEpicFree(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
